module.exports = __webpack_public_path__ + "img/bg.8d72a16e.png";